// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var ProvidedBy;
(function (ProvidedBy) {
    ProvidedBy["PROVIDED_BY_UNSPECIFIED"] = "PROVIDED_BY_UNSPECIFIED";
    ProvidedBy["WEAVE"] = "WEAVE";
    ProvidedBy["OFFICE"] = "OFFICE";
    ProvidedBy["PARTNER"] = "PARTNER";
})(ProvidedBy || (ProvidedBy = {}));
export var ProvidedBy_index;
(function (ProvidedBy_index) {
    ProvidedBy_index[ProvidedBy_index["PROVIDED_BY_UNSPECIFIED"] = 0] = "PROVIDED_BY_UNSPECIFIED";
    ProvidedBy_index[ProvidedBy_index["WEAVE"] = 1] = "WEAVE";
    ProvidedBy_index[ProvidedBy_index["OFFICE"] = 2] = "OFFICE";
    ProvidedBy_index[ProvidedBy_index["PARTNER"] = 3] = "PARTNER";
})(ProvidedBy_index || (ProvidedBy_index = {}));
export var SettingType;
(function (SettingType) {
    SettingType["SETTING_TYPE_UNSPECIFIED"] = "SETTING_TYPE_UNSPECIFIED";
    SettingType["STRING"] = "STRING";
    SettingType["BOOLEAN"] = "BOOLEAN";
    SettingType["INTEGER"] = "INTEGER";
    SettingType["OAUTH_CONFIG"] = "OAUTH_CONFIG";
    SettingType["LIST_OF_STRINGS"] = "LIST_OF_STRINGS";
    SettingType["URL"] = "URL";
    SettingType["LIST_OF_INTS"] = "LIST_OF_INTS";
})(SettingType || (SettingType = {}));
export var SettingType_index;
(function (SettingType_index) {
    SettingType_index[SettingType_index["SETTING_TYPE_UNSPECIFIED"] = 0] = "SETTING_TYPE_UNSPECIFIED";
    SettingType_index[SettingType_index["STRING"] = 1] = "STRING";
    SettingType_index[SettingType_index["BOOLEAN"] = 2] = "BOOLEAN";
    SettingType_index[SettingType_index["INTEGER"] = 3] = "INTEGER";
    SettingType_index[SettingType_index["OAUTH_CONFIG"] = 4] = "OAUTH_CONFIG";
    SettingType_index[SettingType_index["LIST_OF_STRINGS"] = 5] = "LIST_OF_STRINGS";
    SettingType_index[SettingType_index["URL"] = 6] = "URL";
    SettingType_index[SettingType_index["LIST_OF_INTS"] = 7] = "LIST_OF_INTS";
})(SettingType_index || (SettingType_index = {}));
export var IntegrationName;
(function (IntegrationName) {
    IntegrationName["INTEGRATION_UNSPECIFIED"] = "INTEGRATION_UNSPECIFIED";
    IntegrationName["ABELDENT"] = "ABELDENT";
    IntegrationName["ADVANCEDMD"] = "ADVANCEDMD";
    IntegrationName["ADVANTAGE"] = "ADVANTAGE";
    IntegrationName["ATHENA_HEALTH"] = "ATHENA_HEALTH";
    IntegrationName["AVIMARK"] = "AVIMARK";
    IntegrationName["CLIENTRAX"] = "CLIENTRAX";
    IntegrationName["CLOUD_9"] = "CLOUD_9";
    IntegrationName["COMPLETE_CLINIC"] = "COMPLETE_CLINIC";
    IntegrationName["COMPULINK"] = "COMPULINK";
    IntegrationName["CORNERSTONE"] = "CORNERSTONE";
    IntegrationName["CRYSTAL"] = "CRYSTAL";
    IntegrationName["CURVE"] = "CURVE";
    IntegrationName["DAYSMART_VET"] = "DAYSMART_VET";
    IntegrationName["DENTICON"] = "DENTICON";
    IntegrationName["DENTIMAX"] = "DENTIMAX";
    IntegrationName["DENTRIX_ASCEND"] = "DENTRIX_ASCEND";
    IntegrationName["DENTRIX_ENTERPRISE"] = "DENTRIX_ENTERPRISE";
    IntegrationName["DENTRIX_G4"] = "DENTRIX_G4";
    IntegrationName["DENTRIX_G4_RAW"] = "DENTRIX_G4_RAW";
    IntegrationName["DENTRIX_G5"] = "DENTRIX_G5";
    IntegrationName["DOLPHIN"] = "DOLPHIN";
    IntegrationName["DOLPHIN_CLOUD"] = "DOLPHIN_CLOUD";
    IntegrationName["DR_CHRONO"] = "DR_CHRONO";
    IntegrationName["DSN_DENTAL_EXEC"] = "DSN_DENTAL_EXEC";
    IntegrationName["DVM_MANAGER"] = "DVM_MANAGER";
    IntegrationName["DVMAX"] = "DVMAX";
    IntegrationName["EAGLESOFT_16"] = "EAGLESOFT_16";
    IntegrationName["EAGLESOFT_18"] = "EAGLESOFT_18";
    IntegrationName["EASY_DENTAL"] = "EASY_DENTAL";
    IntegrationName["EASY_DENTAL_RAW"] = "EASY_DENTAL_RAW";
    IntegrationName["EDDSON"] = "EDDSON";
    IntegrationName["EMA"] = "EMA";
    IntegrationName["EVET_PRACTICE"] = "EVET_PRACTICE";
    IntegrationName["EYEFINITY"] = "EYEFINITY";
    IntegrationName["HVMS"] = "HVMS";
    IntegrationName["IMPROMED"] = "IMPROMED";
    IntegrationName["INTRAVET"] = "INTRAVET";
    IntegrationName["MACPRACTICE"] = "MACPRACTICE";
    IntegrationName["MAXIMEYES"] = "MAXIMEYES";
    IntegrationName["MINDBODY"] = "MINDBODY";
    IntegrationName["MOCKPMS"] = "MOCKPMS";
    IntegrationName["MODMED"] = "MODMED";
    IntegrationName["NAVETOR"] = "NAVETOR";
    IntegrationName["NEXTECH"] = "NEXTECH";
    IntegrationName["NEXTECH_PRACTICE"] = "NEXTECH_PRACTICE";
    IntegrationName["NEXTGEN"] = "NEXTGEN";
    IntegrationName["OASYS"] = "OASYS";
    IntegrationName["ODLINK"] = "ODLINK";
    IntegrationName["OFFICEMATE"] = "OFFICEMATE";
    IntegrationName["OPENDENTAL"] = "OPENDENTAL";
    IntegrationName["ORTHO_2"] = "ORTHO_2";
    IntegrationName["ORTHOTRAC"] = "ORTHOTRAC";
    IntegrationName["ORTHOTRAC_CLOUD"] = "ORTHOTRAC_CLOUD";
    IntegrationName["PATTERSON_FUSE"] = "PATTERSON_FUSE";
    IntegrationName["PRACTICE_DIRECTOR"] = "PRACTICE_DIRECTOR";
    IntegrationName["PRACTICEWORKS"] = "PRACTICEWORKS";
    IntegrationName["PRACTICEWORKS_CLOUD"] = "PRACTICEWORKS_CLOUD";
    IntegrationName["PROVET_CLOUD"] = "PROVET_CLOUD";
    IntegrationName["QUICKBOOKSONLINE"] = "QUICKBOOKSONLINE";
    IntegrationName["REVOLUTION"] = "REVOLUTION";
    IntegrationName["SENSEI_CLOUD"] = "SENSEI_CLOUD";
    IntegrationName["SOFTDENT_16"] = "SOFTDENT_16";
    IntegrationName["SOFTDENT_CLOUD"] = "SOFTDENT_CLOUD";
    IntegrationName["STRINGSOFT"] = "STRINGSOFT";
    IntegrationName["SYCLE"] = "SYCLE";
    IntegrationName["TOTAL_MD"] = "TOTAL_MD";
    IntegrationName["TRAKNET"] = "TRAKNET";
    IntegrationName["TRAKNET_CLOUD"] = "TRAKNET_CLOUD";
    IntegrationName["TRIPLE_CROWN"] = "TRIPLE_CROWN";
    IntegrationName["UPRISE"] = "UPRISE";
    IntegrationName["VIA"] = "VIA";
    IntegrationName["VTECH_PLATINUM"] = "VTECH_PLATINUM";
    IntegrationName["WEAVEPMS"] = "WEAVEPMS";
    IntegrationName["WINOMS"] = "WINOMS";
    IntegrationName["WINOMS_CLOUD"] = "WINOMS_CLOUD";
    IntegrationName["ORTHOTRAC_CLOUD_V2"] = "ORTHOTRAC_CLOUD_V2";
    IntegrationName["SOFTDENT_CLOUD_V2"] = "SOFTDENT_CLOUD_V2";
    IntegrationName["WINOMS_CLOUD_V2"] = "WINOMS_CLOUD_V2";
    IntegrationName["PRACTICEWORKS_CLOUD_V2"] = "PRACTICEWORKS_CLOUD_V2";
    IntegrationName["BOOKER"] = "BOOKER";
    IntegrationName["EMR4D"] = "EMR4D";
    IntegrationName["DOLPHIN_BLUE"] = "DOLPHIN_BLUE";
    IntegrationName["ACUITY"] = "ACUITY";
    IntegrationName["ECLINICALWORKS"] = "ECLINICALWORKS";
    IntegrationName["OMS_VISION"] = "OMS_VISION";
    IntegrationName["VERADIGM"] = "VERADIGM";
    IntegrationName["VERADIGM_CLOUD"] = "VERADIGM_CLOUD";
    IntegrationName["INFINITE_VT"] = "INFINITE_VT";
    IntegrationName["SHEPHERD"] = "SHEPHERD";
    IntegrationName["EZYVET"] = "EZYVET";
    IntegrationName["MINDBODYV6"] = "MINDBODYV6";
    IntegrationName["PDDS_DENTICON"] = "PDDS_DENTICON";
    IntegrationName["OPENDENTAL_CLOUD"] = "OPENDENTAL_CLOUD";
    IntegrationName["DATAPOINT"] = "DATAPOINT";
    IntegrationName["EYEFINITY_V2"] = "EYEFINITY_V2";
    IntegrationName["OPENDENTAL_CLOUD_LOCAL"] = "OPENDENTAL_CLOUD_LOCAL";
    IntegrationName["PROMPT"] = "PROMPT";
    IntegrationName["NEXTGENOFFICE"] = "NEXTGENOFFICE";
    IntegrationName["PRACTICEFUSION"] = "PRACTICEFUSION";
    IntegrationName["CORNERSTONE_CLOUD"] = "CORNERSTONE_CLOUD";
    IntegrationName["DSN_CLOUD"] = "DSN_CLOUD";
    IntegrationName["NEO"] = "NEO";
    IntegrationName["ORTHO2EDGE"] = "ORTHO2EDGE";
    IntegrationName["MAXIMEYES_SELFHOSTED"] = "MAXIMEYES_SELFHOSTED";
})(IntegrationName || (IntegrationName = {}));
export var IntegrationName_index;
(function (IntegrationName_index) {
    IntegrationName_index[IntegrationName_index["INTEGRATION_UNSPECIFIED"] = 0] = "INTEGRATION_UNSPECIFIED";
    IntegrationName_index[IntegrationName_index["ABELDENT"] = 1] = "ABELDENT";
    IntegrationName_index[IntegrationName_index["ADVANCEDMD"] = 2] = "ADVANCEDMD";
    IntegrationName_index[IntegrationName_index["ADVANTAGE"] = 3] = "ADVANTAGE";
    IntegrationName_index[IntegrationName_index["ATHENA_HEALTH"] = 4] = "ATHENA_HEALTH";
    IntegrationName_index[IntegrationName_index["AVIMARK"] = 5] = "AVIMARK";
    IntegrationName_index[IntegrationName_index["CLIENTRAX"] = 6] = "CLIENTRAX";
    IntegrationName_index[IntegrationName_index["CLOUD_9"] = 7] = "CLOUD_9";
    IntegrationName_index[IntegrationName_index["COMPLETE_CLINIC"] = 8] = "COMPLETE_CLINIC";
    IntegrationName_index[IntegrationName_index["COMPULINK"] = 9] = "COMPULINK";
    IntegrationName_index[IntegrationName_index["CORNERSTONE"] = 10] = "CORNERSTONE";
    IntegrationName_index[IntegrationName_index["CRYSTAL"] = 11] = "CRYSTAL";
    IntegrationName_index[IntegrationName_index["CURVE"] = 12] = "CURVE";
    IntegrationName_index[IntegrationName_index["DAYSMART_VET"] = 13] = "DAYSMART_VET";
    IntegrationName_index[IntegrationName_index["DENTICON"] = 14] = "DENTICON";
    IntegrationName_index[IntegrationName_index["DENTIMAX"] = 15] = "DENTIMAX";
    IntegrationName_index[IntegrationName_index["DENTRIX_ASCEND"] = 16] = "DENTRIX_ASCEND";
    IntegrationName_index[IntegrationName_index["DENTRIX_ENTERPRISE"] = 17] = "DENTRIX_ENTERPRISE";
    IntegrationName_index[IntegrationName_index["DENTRIX_G4"] = 18] = "DENTRIX_G4";
    IntegrationName_index[IntegrationName_index["DENTRIX_G4_RAW"] = 19] = "DENTRIX_G4_RAW";
    IntegrationName_index[IntegrationName_index["DENTRIX_G5"] = 20] = "DENTRIX_G5";
    IntegrationName_index[IntegrationName_index["DOLPHIN"] = 21] = "DOLPHIN";
    IntegrationName_index[IntegrationName_index["DOLPHIN_CLOUD"] = 22] = "DOLPHIN_CLOUD";
    IntegrationName_index[IntegrationName_index["DR_CHRONO"] = 23] = "DR_CHRONO";
    IntegrationName_index[IntegrationName_index["DSN_DENTAL_EXEC"] = 24] = "DSN_DENTAL_EXEC";
    IntegrationName_index[IntegrationName_index["DVM_MANAGER"] = 25] = "DVM_MANAGER";
    IntegrationName_index[IntegrationName_index["DVMAX"] = 26] = "DVMAX";
    IntegrationName_index[IntegrationName_index["EAGLESOFT_16"] = 27] = "EAGLESOFT_16";
    IntegrationName_index[IntegrationName_index["EAGLESOFT_18"] = 28] = "EAGLESOFT_18";
    IntegrationName_index[IntegrationName_index["EASY_DENTAL"] = 29] = "EASY_DENTAL";
    IntegrationName_index[IntegrationName_index["EASY_DENTAL_RAW"] = 30] = "EASY_DENTAL_RAW";
    IntegrationName_index[IntegrationName_index["EDDSON"] = 31] = "EDDSON";
    IntegrationName_index[IntegrationName_index["EMA"] = 32] = "EMA";
    IntegrationName_index[IntegrationName_index["EVET_PRACTICE"] = 33] = "EVET_PRACTICE";
    IntegrationName_index[IntegrationName_index["EYEFINITY"] = 34] = "EYEFINITY";
    IntegrationName_index[IntegrationName_index["HVMS"] = 35] = "HVMS";
    IntegrationName_index[IntegrationName_index["IMPROMED"] = 36] = "IMPROMED";
    IntegrationName_index[IntegrationName_index["INTRAVET"] = 37] = "INTRAVET";
    IntegrationName_index[IntegrationName_index["MACPRACTICE"] = 38] = "MACPRACTICE";
    IntegrationName_index[IntegrationName_index["MAXIMEYES"] = 39] = "MAXIMEYES";
    IntegrationName_index[IntegrationName_index["MINDBODY"] = 40] = "MINDBODY";
    IntegrationName_index[IntegrationName_index["MOCKPMS"] = 41] = "MOCKPMS";
    IntegrationName_index[IntegrationName_index["MODMED"] = 42] = "MODMED";
    IntegrationName_index[IntegrationName_index["NAVETOR"] = 43] = "NAVETOR";
    IntegrationName_index[IntegrationName_index["NEXTECH"] = 44] = "NEXTECH";
    IntegrationName_index[IntegrationName_index["NEXTECH_PRACTICE"] = 45] = "NEXTECH_PRACTICE";
    IntegrationName_index[IntegrationName_index["NEXTGEN"] = 46] = "NEXTGEN";
    IntegrationName_index[IntegrationName_index["OASYS"] = 47] = "OASYS";
    IntegrationName_index[IntegrationName_index["ODLINK"] = 48] = "ODLINK";
    IntegrationName_index[IntegrationName_index["OFFICEMATE"] = 49] = "OFFICEMATE";
    IntegrationName_index[IntegrationName_index["OPENDENTAL"] = 50] = "OPENDENTAL";
    IntegrationName_index[IntegrationName_index["ORTHO_2"] = 51] = "ORTHO_2";
    IntegrationName_index[IntegrationName_index["ORTHOTRAC"] = 52] = "ORTHOTRAC";
    IntegrationName_index[IntegrationName_index["ORTHOTRAC_CLOUD"] = 53] = "ORTHOTRAC_CLOUD";
    IntegrationName_index[IntegrationName_index["PATTERSON_FUSE"] = 54] = "PATTERSON_FUSE";
    IntegrationName_index[IntegrationName_index["PRACTICE_DIRECTOR"] = 55] = "PRACTICE_DIRECTOR";
    IntegrationName_index[IntegrationName_index["PRACTICEWORKS"] = 56] = "PRACTICEWORKS";
    IntegrationName_index[IntegrationName_index["PRACTICEWORKS_CLOUD"] = 57] = "PRACTICEWORKS_CLOUD";
    IntegrationName_index[IntegrationName_index["PROVET_CLOUD"] = 58] = "PROVET_CLOUD";
    IntegrationName_index[IntegrationName_index["QUICKBOOKSONLINE"] = 59] = "QUICKBOOKSONLINE";
    IntegrationName_index[IntegrationName_index["REVOLUTION"] = 60] = "REVOLUTION";
    IntegrationName_index[IntegrationName_index["SENSEI_CLOUD"] = 61] = "SENSEI_CLOUD";
    IntegrationName_index[IntegrationName_index["SOFTDENT_16"] = 62] = "SOFTDENT_16";
    IntegrationName_index[IntegrationName_index["SOFTDENT_CLOUD"] = 63] = "SOFTDENT_CLOUD";
    IntegrationName_index[IntegrationName_index["STRINGSOFT"] = 64] = "STRINGSOFT";
    IntegrationName_index[IntegrationName_index["SYCLE"] = 65] = "SYCLE";
    IntegrationName_index[IntegrationName_index["TOTAL_MD"] = 66] = "TOTAL_MD";
    IntegrationName_index[IntegrationName_index["TRAKNET"] = 67] = "TRAKNET";
    IntegrationName_index[IntegrationName_index["TRAKNET_CLOUD"] = 68] = "TRAKNET_CLOUD";
    IntegrationName_index[IntegrationName_index["TRIPLE_CROWN"] = 69] = "TRIPLE_CROWN";
    IntegrationName_index[IntegrationName_index["UPRISE"] = 70] = "UPRISE";
    IntegrationName_index[IntegrationName_index["VIA"] = 71] = "VIA";
    IntegrationName_index[IntegrationName_index["VTECH_PLATINUM"] = 72] = "VTECH_PLATINUM";
    IntegrationName_index[IntegrationName_index["WEAVEPMS"] = 73] = "WEAVEPMS";
    IntegrationName_index[IntegrationName_index["WINOMS"] = 74] = "WINOMS";
    IntegrationName_index[IntegrationName_index["WINOMS_CLOUD"] = 75] = "WINOMS_CLOUD";
    IntegrationName_index[IntegrationName_index["ORTHOTRAC_CLOUD_V2"] = 76] = "ORTHOTRAC_CLOUD_V2";
    IntegrationName_index[IntegrationName_index["SOFTDENT_CLOUD_V2"] = 77] = "SOFTDENT_CLOUD_V2";
    IntegrationName_index[IntegrationName_index["WINOMS_CLOUD_V2"] = 78] = "WINOMS_CLOUD_V2";
    IntegrationName_index[IntegrationName_index["PRACTICEWORKS_CLOUD_V2"] = 79] = "PRACTICEWORKS_CLOUD_V2";
    IntegrationName_index[IntegrationName_index["BOOKER"] = 80] = "BOOKER";
    IntegrationName_index[IntegrationName_index["EMR4D"] = 81] = "EMR4D";
    IntegrationName_index[IntegrationName_index["DOLPHIN_BLUE"] = 82] = "DOLPHIN_BLUE";
    IntegrationName_index[IntegrationName_index["ACUITY"] = 83] = "ACUITY";
    IntegrationName_index[IntegrationName_index["ECLINICALWORKS"] = 84] = "ECLINICALWORKS";
    IntegrationName_index[IntegrationName_index["OMS_VISION"] = 85] = "OMS_VISION";
    IntegrationName_index[IntegrationName_index["VERADIGM"] = 86] = "VERADIGM";
    IntegrationName_index[IntegrationName_index["VERADIGM_CLOUD"] = 87] = "VERADIGM_CLOUD";
    IntegrationName_index[IntegrationName_index["INFINITE_VT"] = 88] = "INFINITE_VT";
    IntegrationName_index[IntegrationName_index["SHEPHERD"] = 89] = "SHEPHERD";
    IntegrationName_index[IntegrationName_index["EZYVET"] = 90] = "EZYVET";
    IntegrationName_index[IntegrationName_index["MINDBODYV6"] = 91] = "MINDBODYV6";
    IntegrationName_index[IntegrationName_index["PDDS_DENTICON"] = 92] = "PDDS_DENTICON";
    IntegrationName_index[IntegrationName_index["OPENDENTAL_CLOUD"] = 93] = "OPENDENTAL_CLOUD";
    IntegrationName_index[IntegrationName_index["DATAPOINT"] = 94] = "DATAPOINT";
    IntegrationName_index[IntegrationName_index["EYEFINITY_V2"] = 95] = "EYEFINITY_V2";
    IntegrationName_index[IntegrationName_index["OPENDENTAL_CLOUD_LOCAL"] = 96] = "OPENDENTAL_CLOUD_LOCAL";
    IntegrationName_index[IntegrationName_index["PROMPT"] = 97] = "PROMPT";
    IntegrationName_index[IntegrationName_index["NEXTGENOFFICE"] = 98] = "NEXTGENOFFICE";
    IntegrationName_index[IntegrationName_index["PRACTICEFUSION"] = 99] = "PRACTICEFUSION";
    IntegrationName_index[IntegrationName_index["CORNERSTONE_CLOUD"] = 100] = "CORNERSTONE_CLOUD";
    IntegrationName_index[IntegrationName_index["DSN_CLOUD"] = 101] = "DSN_CLOUD";
    IntegrationName_index[IntegrationName_index["NEO"] = 102] = "NEO";
    IntegrationName_index[IntegrationName_index["ORTHO2EDGE"] = 103] = "ORTHO2EDGE";
    IntegrationName_index[IntegrationName_index["MAXIMEYES_SELFHOSTED"] = 104] = "MAXIMEYES_SELFHOSTED";
})(IntegrationName_index || (IntegrationName_index = {}));
export var IntegrationType;
(function (IntegrationType) {
    IntegrationType["INTEGRATION_TYPE_UNSPECIFIED"] = "INTEGRATION_TYPE_UNSPECIFIED";
    IntegrationType["ON_PREM"] = "ON_PREM";
    IntegrationType["CLOUD"] = "CLOUD";
    IntegrationType["FILE_UPLOAD"] = "FILE_UPLOAD";
    IntegrationType["MANUAL_ENTRY"] = "MANUAL_ENTRY";
})(IntegrationType || (IntegrationType = {}));
export var IntegrationType_index;
(function (IntegrationType_index) {
    IntegrationType_index[IntegrationType_index["INTEGRATION_TYPE_UNSPECIFIED"] = 0] = "INTEGRATION_TYPE_UNSPECIFIED";
    IntegrationType_index[IntegrationType_index["ON_PREM"] = 1] = "ON_PREM";
    IntegrationType_index[IntegrationType_index["CLOUD"] = 2] = "CLOUD";
    IntegrationType_index[IntegrationType_index["FILE_UPLOAD"] = 3] = "FILE_UPLOAD";
    IntegrationType_index[IntegrationType_index["MANUAL_ENTRY"] = 4] = "MANUAL_ENTRY";
})(IntegrationType_index || (IntegrationType_index = {}));
export var OperatingSystem;
(function (OperatingSystem) {
    OperatingSystem["OPERATING_SYSTEM_UNSPECIFIED"] = "OPERATING_SYSTEM_UNSPECIFIED";
    OperatingSystem["WINDOWS"] = "WINDOWS";
    OperatingSystem["DARWIN"] = "DARWIN";
    OperatingSystem["LINUX"] = "LINUX";
})(OperatingSystem || (OperatingSystem = {}));
export var OperatingSystem_index;
(function (OperatingSystem_index) {
    OperatingSystem_index[OperatingSystem_index["OPERATING_SYSTEM_UNSPECIFIED"] = 0] = "OPERATING_SYSTEM_UNSPECIFIED";
    OperatingSystem_index[OperatingSystem_index["WINDOWS"] = 1] = "WINDOWS";
    OperatingSystem_index[OperatingSystem_index["DARWIN"] = 2] = "DARWIN";
    OperatingSystem_index[OperatingSystem_index["LINUX"] = 3] = "LINUX";
})(OperatingSystem_index || (OperatingSystem_index = {}));
export var Availability;
(function (Availability) {
    Availability["UNSPECIFIED"] = "UNSPECIFIED";
    Availability["AVAILABLE"] = "AVAILABLE";
    Availability["NOT_AVAILABLE"] = "NOT_AVAILABLE";
    Availability["IN_DEVELOPMENT"] = "IN_DEVELOPMENT";
    Availability["BETA"] = "BETA";
})(Availability || (Availability = {}));
export var Availability_index;
(function (Availability_index) {
    Availability_index[Availability_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    Availability_index[Availability_index["AVAILABLE"] = 1] = "AVAILABLE";
    Availability_index[Availability_index["NOT_AVAILABLE"] = 2] = "NOT_AVAILABLE";
    Availability_index[Availability_index["IN_DEVELOPMENT"] = 3] = "IN_DEVELOPMENT";
    Availability_index[Availability_index["BETA"] = 4] = "BETA";
})(Availability_index || (Availability_index = {}));
export var Integration_Status;
(function (Integration_Status) {
    Integration_Status["UNSPECIFIED"] = "UNSPECIFIED";
    Integration_Status["AVAILABLE"] = "AVAILABLE";
    Integration_Status["NOT_AVAILABLE"] = "NOT_AVAILABLE";
    Integration_Status["COMING_SOON"] = "COMING_SOON";
})(Integration_Status || (Integration_Status = {}));
export var Integration_Status_index;
(function (Integration_Status_index) {
    Integration_Status_index[Integration_Status_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    Integration_Status_index[Integration_Status_index["AVAILABLE"] = 1] = "AVAILABLE";
    Integration_Status_index[Integration_Status_index["NOT_AVAILABLE"] = 2] = "NOT_AVAILABLE";
    Integration_Status_index[Integration_Status_index["COMING_SOON"] = 3] = "COMING_SOON";
})(Integration_Status_index || (Integration_Status_index = {}));
